module.exports = __webpack_public_path__ + "img/134.8f7f250d.jpg";